/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import RichTextField from '@molecules/RichTextField';
import { transformApiFormErrors } from '@utils/form';
import { ContentModuleModal, TextField } from '@molecules';
import BackgroundSelect from '@organisms/BackgroundSelect/index';

import Form from '../Form';

import Item from './Item';
import { FORM_FIELD, FORM_FIELDS } from './constants';

const TextBlock = ({
  visible,
  hide,
  previewImg,
  onDelete,
  onSubmit,
  initialValues: data,
  errors,
  isUltimateDesign,
}) => {
  const [form] = Form.useForm(FORM_FIELDS);
  const initialValues = React.useMemo(() => form.deserialize(data), [data, form]);

  React.useEffect(() => {
    if (visible) {
      // Again a dirty hack to show error when modal opens first time because form is working on subscriptions.
      setTimeout(() => {
        form.setFields(transformApiFormErrors(errors?.content, FORM_FIELDS));
      });
    }
  }, [visible, errors, form]);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleOnValuesChange = ({ [FORM_FIELD.BACKGROUND.name]: backgroundImage }) => {
    if (backgroundImage) {
      form.setFieldsValue({
        [FORM_FIELD.BACKGROUND.name]: { id: backgroundImage.id, edited: backgroundImage.edited },
      });
    }
  };

  // Should be unique name, otherwise WYSIWYG editor won't work correctly if multiple text blocks are added
  const formName = React.useMemo(() => `form_in_modal-${Math.random()}`, []);

  return (
    <ContentModuleModal
      visible={visible}
      title="Text block"
      subtitle="Add a block of formatted text - you can include images and links."
      okText={onDelete ? 'SAVE CHANGES' : 'ADD TEXT BLOCK'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onSerializedFinish={handleSubmit}
        onValuesChange={handleOnValuesChange}
        name={formName}
      >
        {isUltimateDesign ? (
          <>
            <TextField {...FORM_FIELD.TITLE} />
            <TextField {...FORM_FIELD.URL} />
            <TextField {...FORM_FIELD.URL_TEXT} />
            <RichTextField {...FORM_FIELD.CONTENT} />
            <BackgroundSelect
              isImgBackground={!!data?.backgroundImageId}
              background={FORM_FIELD.BACKGROUND}
              backgroundColours={FORM_FIELD.BACKGROUND_COLOUR}
            />
          </>
        ) : (
          <RichTextField {...FORM_FIELD.CONTENT} />
        )}
      </Form>
    </ContentModuleModal>
  );
};

TextBlock.Item = Item;

export default TextBlock;
